import { render, staticRenderFns } from "./DistributorTable.vue?vue&type=template&id=0dba34ce"
import script from "./DistributorTable.vue?vue&type=script&lang=js"
export * from "./DistributorTable.vue?vue&type=script&lang=js"
import style0 from "./DistributorTable.vue?vue&type=style&index=0&id=0dba34ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports